// Quote / Mockup Modal
(function () {
  const overlay = document.getElementById('QuoteModalOverlay');
  if (!overlay) return;

  function openQuoteModal() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuoteModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Close button inside modal
  const closeBtn = document.getElementById('QuoteModalClose');
  if (closeBtn) closeBtn.addEventListener('click', closeQuoteModal);

  // Close on form submit
  const form = overlay.querySelector('form');
  if (form) form.addEventListener('submit', function () {
    setTimeout(closeQuoteModal, 500);
  });

  // Expose globally so any button anywhere on the site can call it
  window.openQuoteModal = openQuoteModal;
  window.closeQuoteModal = closeQuoteModal;
})();
